/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-21 10:49:04
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-25 15:43:34
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductReview/ProductReviewDetail/ReviewCard/index.tsx
 */
import React from 'react';
import css from './css.module.less';
import Title from './Title';
import Content from './Content';
import { SectionCollapse } from '@/src/components/Antd';
import { AllTypes, instanceType } from 'src/tools/helper';
import { get } from 'lodash';

const Card = (props) => {
  const {
    replies,
    rating,
    title,
    createdDate,
    orderNo,
    orderUuid,
    content,
    fromSalesChannel,

    medias,
    productReviewSalesChannels,
    uuid,
    contentFunctions,
    titleFunctions,
    status,
    customer,
    customerName: _customerName,
    staffName,
    ...rest
  } = props;

  const firstName = get(customer, 'firstName');
  const lastName = get(customer, 'lastName');
  const customerName = _customerName || `${firstName || ''} ${lastName || ''}`;
  const customerDatabaseUuid = get(customer, 'customerDatabaseUuid');

  const hasReply = (replies || []).length > 0;
  const customerUuid = get(customer, 'uuid');
  const isFake = !(!!customerUuid && !!fromSalesChannel);

  //const { setReplyOpen } = useContext(ReplyContext);
  const { collapseOpen, setCollapseOpen } = props;
  return (
    <SectionCollapse
      open={collapseOpen}
      titleContainerClassName={!collapseOpen ? '' : css.titleRewritter}
      key={uuid}
      id={uuid}
      //titleStyle={i.style}
      title={
        <Title
          func={titleFunctions}
          isFake={isFake}
          status={status}
          title={title}
          rating={rating}
          hasReply={hasReply}
          reviewUuid={uuid}
        />
      }
      content={
        <Content
          func={contentFunctions}
          data={{
            status,
            replies,
            createdDate,
            orderNo,
            orderUuid,
            content,
            fromSalesChannel,
            customerName,
            staffName,
            medias,
            productReviewSalesChannels,
            reviewUuid: uuid,
            isFake,
            customerUuid,
            customerDatabaseUuid,
            ...rest,
          }}
        />
      }
      openMargin={16}
      onClickTrigger={setCollapseOpen}
    />
  );
};

export const ReplyContext = React.createContext(null);
const WrappedCard = (Comp) => {
  const WComp = (props) => {
    const [replyOpen, setReplyOpen] = React.useState(false);
    const [collapseOpen, setCollapseOpen] = React.useState(false);

    const _setReplyOpen = (status?) => {
      if (instanceType(status) !== AllTypes.Boolean) {
        setReplyOpen(!replyOpen);
      } else {
        setReplyOpen(status);
      }
    };
    const _setCollapseOpen = (status?) => {
      if (instanceType(status) !== AllTypes.Boolean) {
        setCollapseOpen(!collapseOpen);
      } else {
        setCollapseOpen(status);
      }
    };
    return (
      <ReplyContext.Provider
        value={{
          setCollapseOpen: _setCollapseOpen,
          setReplyOpen: _setReplyOpen,
          replyOpen,
        }}>
        <Comp
          collapseOpen={collapseOpen}
          setCollapseOpen={setCollapseOpen}
          {...props}
        />
      </ReplyContext.Provider>
    );
  };
  return WComp;
};

export default WrappedCard(Card);
